import {
  VuexModule,
  Module,
  getModule,
  Mutation,
  Action,
} from "vuex-module-decorators";
import store from "@/store";
import { FiltroSolicitacaoOrcamentoModel } from "@/models/orcamento-auto-online/FiltroSolicitacaoOrcamentoModel";

export interface IFiltroOrcamentoSolicitadoStore extends VuexModule {
  filtroSolicitacaoOrcamentoModel: FiltroSolicitacaoOrcamentoModel | null;
}

const getDefaultState = () => {
  return {
    filtroSolicitacaoOrcamentoModel: null
  };
};

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: "FiltroOrcamentoSolicitado",
})
class FiltroOrcamentoSolicitadoStore extends VuexModule implements IFiltroOrcamentoSolicitadoStore {
  filtroSolicitacaoOrcamentoModel: FiltroSolicitacaoOrcamentoModel | null = null;

  @Mutation
  RESET() {
    Object.assign(this, getDefaultState());
  }

  @Mutation
  SET_DADOS_BASICOS(payload: FiltroSolicitacaoOrcamentoModel) {
    this.filtroSolicitacaoOrcamentoModel = payload;
  }

  get filtroAtual() {
    return this.filtroSolicitacaoOrcamentoModel;
  }

}

export const filtroOrcamentoSolicitadoStore = getModule(FiltroOrcamentoSolicitadoStore);
